import { useMemo } from "react";

import { FieldType } from "../../../constants";
import { FilterTypes } from "../../../constants/filterTypes";
import { BoolColumnFilter } from "../components/filters/boolColumnFilter";
import { DateColumnFilter } from "../components/filters/dateColumnFilter";
import { DefaultColumnFilter } from "../components/filters/defaultColumnFilter";
import { EnumColumnFilter } from "../components/filters/enumColumnFilter";
import { NumberColumnFilter } from "../components/filters/numberColumnFilter";

export const useTableColumns = (
	dataTableColumnSettings,
	selectedOrg,
	selectedSite,
	isSysAdmin,
	isRoutePermitted,
) => {
	return useMemo(
		() =>
			dataTableColumnSettings.columns
				.filter(
					(column) =>
						column.isVisible !== false &&
						isRoutePermitted(
							{
								...selectedOrg.permissions,
								...selectedSite.permissions,
							},
							column?.permissions,
							isSysAdmin,
						),
				)
				.map((column) => {
					if (column.defaultFilterValue !== undefined) {
						column.defaultFilterValue = column.defaultFilterValue;
					}

					switch (column.type) {
						case FieldType.DATE:
							column.filter = FilterTypes.DATE;
							column.Filter = DateColumnFilter(
								false,
								column.showIsEmpty,
							);
							break;
						case FieldType.DATE_EXPIRED:
							column.filter = FilterTypes.DATE;
							column.Filter = DateColumnFilter(
								true,
								column.showIsEmpty,
							);
							break;
						case FieldType.ENUM:
							column.filter = FilterTypes.ENUM;
							column.Filter = EnumColumnFilter;
							break;
						case FieldType.NUMBER:
							column.filter = FilterTypes.NUMBER;
							column.Filter = NumberColumnFilter;
							break;
						case FieldType.BOOLEAN:
						case FieldType.TOGGLE_SWITCH:
							column.filter = FilterTypes.BOOLEAN;
							column.Filter = BoolColumnFilter;
							break;
						case FieldType.USER:
							column.filter = FilterTypes.USER;
							break;
						default:
							column.Filter = DefaultColumnFilter;
							break;
					}

					if (column.filter === FilterTypes.NUMBER)
						column.Filter = NumberColumnFilter;

					return column;
				}),
		[dataTableColumnSettings, selectedOrg, selectedSite, isSysAdmin],
	);
};
